// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"97218e37","149":"a5fecbca","189":"68652481","397":"60ccf500","424":"b841037b","490":"e26ed671","518":"586b0d40","667":"cb4978a0","781":"a7a49ddb"}[chunkId] + ".chunk.js";
};